/*
 * File: HandleOrders.js
 * Project: mp-mobile-app
 *
 * Created by Rob Rothe
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description:  Handles fetching the orders list and the mine/all tabs
 */
import { Component } from "react";
import { observer } from "mobx-react";
import OrdersAppStore from "services/orders/store/models/OrdersAppStore";
import UIStore from "../store/UI";
import PropTypes from "prop-types";
import { StoreContext } from "utils/useStore";

class HandleOrders extends Component {
  static contextType = StoreContext;

  get ordersStore() {
    return this.context.getStore(OrdersAppStore);
  }

  get uiStore() {
    return this.context.getStore(UIStore);
  }

  componentDidMount() {
    this.fetchOrders();
  }

  fetchOrders = async () => {
    //Checks to see if orders have been fetched already. If they have, we simply refresh orders in case of any
    //new orders (orders added, taken away, etc.)
    if (!this.ordersStore.ordersFetched) await this.ordersStore.fetchOrders();
    else await this.ordersStore.refreshOrders();
  };

  handleTabChange = async value => {
    this.uiStore.updateFilterTabValue(value);
    await this.ordersStore.refreshOrders();
  };

  getOrders = () => {
    const {
      orders,
      isNextPageLoading,
      ordersCount,
      usersOrdersCount,
      ordersFetched
    } = this.ordersStore;

    return {
      fetched: ordersFetched,
      orders: orders,
      hasNextPage: this.ordersStore.hasNextPage,
      isNextPageLoading: isNextPageLoading,
      ordersCount: ordersCount,
      usersOrders: orders,
      usersOrdersCount: usersOrdersCount,
      tabValue: this.uiStore.filterTabValue
    };
  };

  render() {
    const data = this.getOrders();
    const actions = {
      handleTabChange: this.handleTabChange,
      loadNextPage: () => this.ordersStore.loadMoreItems()
    };
    return this.props.render(data, actions);
  }
}

HandleOrders.propTypes = {
  render: PropTypes.func.isRequired
};

export default observer(HandleOrders);
